import {Pipe, PipeTransform} from '@angular/core';
import {NationalRegisterNumber, NationalRegisterNumberFormatter} from '@atlas/businesstypes';

/**
 * @ngModule BusinessTypesModule
 */
@Pipe({name: 'atlasNationalRegisterNumber'})
export class NationalRegisterNumberPipe implements PipeTransform {
  public transform(value: any): string {
    return NationalRegisterNumber.isNationalRegisterNumber(value)
      ? NationalRegisterNumberFormatter.format(value)
      : value;
  }
}
